import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

/* Layout / shared components */
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import StickyBanner from "./components/StickyBanner";
import ContactSection from "./components/ContactSection";
import WhyChooseMe from "./components/WhyChooseMe";
import GallerySection from "./components/GallerySection";
import Footer from "./components/Footer";

/* Pages */
import Booking from "./pages/Booking";
import Impressum from "./pages/Impressum";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Contact from "./pages/Contact";

/* ================= HOME ================= */

function Home() {
  return (
    <>
      <Navbar />

      <Hero />
      <ContactSection />
      <WhyChooseMe />
      <GallerySection />

      <Footer />
    </>
  );
}

/* ================= APP ================= */

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Home */}
        <Route path="/" element={<Home />} />

        {/* Pages */}
        <Route
          path="/contact"
          element={
            <>
              <Navbar />
              <Contact />
              <Footer />
            </>
          }
        />

        <Route
          path="/impressum"
          element={
            <>
              <Navbar />
              <Impressum />
              <Footer />
            </>
          }
        />

        <Route
          path="/adatvedelem"
          element={
            <>
              <Navbar />
              <PrivacyPolicy />
              <Footer />
            </>
          }
        />
      </Routes>
    </Router>
  );
}
